import React from 'react';
import { Redirect } from '../../../Router';
import { recruitmentRoutes } from './routes';

export const RedirectToRecruitmentHome: React.FC = () => {
  return <Redirect to={recruitmentRoutes.jobsList.route} />;
};

export default RedirectToRecruitmentHome;
